import React, { Component } from 'react'
import Header from '../../components/Headers/Header';
import { Container, Form, FormGroup, Label, Input, Button, Badge, ListGroup, ListGroupItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Progress } from 'reactstrap';
import { readyToApproveTask, readyToApproveEditorTask, localizerComplete, getTaskById, updateTask, addToCms, assignToMe } from 'services/taskService';
import { downloadFile } from 'services/downloadService';
import { getCategoryByCultureId } from 'services/categoryService';
import { getCultures } from 'services/cultureService';
import axios from 'axios';
import { withAlert } from 'react-alert'
import { getCountry } from 'services/roleService'
import { saveAs } from 'file-saver';
import { confirmAlert } from 'react-confirm-alert';
import { Prompt } from 'react-router'
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import RollbarErrorTracking from '../../log/RollbarErrorTracking';
import { cdnPath, zoomMediaAPI } from "../../services/config"

class ProcessTask extends Component {

    constructor() {
        super();
        this.state = this.defaultState();

        this.token = window.zoomCrypt.get("token")
        this.networkId = window.zoomCrypt.get("networkId");
        this.i = 0;
        let url = new URL(window.location.href);
        this.taskType = url.searchParams.get("task");
        this.signal = axios.CancelToken.source();        
    }

    defaultState() {
      return {
        files: [],
        hdVideo: null,
        video: null,
        image: null,
        cleanVideo: null,
        cleanImage: null,
        premierProject: null,
        extraRawFiles: [],
        assetFiles: [],
        uploadVideoProgress: {},
        uploadId: [],
        backendUrl: `${zoomMediaAPI}/chunkupload`,
        inc: 0,
        showTaskDetail: {},
        uploadedFiles: [],
        taskEditTitle: "",
        taskEditDescription: "",
        taskEditCountry: "",
        taskEditCity: "",
        taskEditIdea: "",
        taskEditPrice: 0,
        elements: [],
        leaveMessage: false,
        currentCategories: [],
        keywordsLabel: [],
        categoriesValue: [],
        categories: [],
        keywords: [],
        cultureData: [],
        downloadedFiles: [],
        showDownloadArea: false,
        taskFound: false,
        countryData: [],
        selectedCountry: [],
        showUploadArea: false,
        disableAddToCmsButton: false
      };
    }

    refreshPage() {
      this.setState(this.defaultState(), () => this.componentDidMount()); 
    }

    async getCountry(){
      const response = await getCountry(this.token);
      let initCountry = [];
      response.countries.forEach((c) => {
          initCountry.push({
              label: c.Name,
              value: c.Id
          })
      })

      this.setState({
          countryData: initCountry,
      })
  }

    handleChange = e => {
      this.setState({ [e.target.name]: e.target.value });
    }

    getCultures = async () =>{
      const response = await getCultures(this.token);
      if(response.success){
          let initialCultures = [];
          initialCultures = response.culture.map((culture) => {
              if(culture.IsActive){
                  return culture;
              }
          })

          this.setState({
              cultureData: initialCultures
          })
      }
  }

    getCategories = async () =>{
      let cultureId = this.state.showTaskDetail?.questType === "localizer" ? this.state.showTaskDetail?.cultureId : 8;
      const response = await getCategoryByCultureId(this.token, cultureId);
      const responseTask = await getTaskById(this.token, this.networkId, this.props.match.params.id);

      if(response.success){
          let initialCategories = [];
          let initialCategoriesEdit = [];
          let initialCurrentCategories = [];

          response.category.forEach((category) => {
              if(category !== undefined){
                  initialCategories.push({ category })
              }

              initialCategoriesEdit.push({
                  value: category.Id,
                  label: category.IsIab ? `${category.Name} ${category.ShortName}` : category.Name,
              })

              if(responseTask.length > 0){
                responseTask[0].data.categories.map((taskCat) => {
                  if(category.Id === taskCat){
                      initialCurrentCategories.push({
                          value: category.Id,
                          label: category.IsIab ? `${category.Name} ${category.ShortName}` : category.Name,
                      })
                  }
              })
              }
          })

          this.setState({
              categoryData: initialCategories,
              currentCategories: initialCurrentCategories,
              categories: initialCategoriesEdit.sort((a, b) => a.label.localeCompare(b.label)),
          })
      }
  }

  downloadMessage() {
    return(
        <div className="download-message-area">
            <img width="100" src="data:image/png;base64,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" alt="zoomin"></img><h4>Downladed Files ...</h4>
              {this.state.downloadedFiles.map((file) =>
                  <li key={file}>{ file } <img src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg" width="14" alt="zoomin"></img></li>
              )}
          </div>
      )
  }

    fileNameNormalizer(text) {
      let charMap = {Ç:'C',Ö:'O',Ş:'S',İ:'I',I:'i',Ü:'U',Ğ:'G',ç:'c',ö:'o',ş:'s',ı:'i',ü:'u',ğ:'g'};
      let str_array = text.split('');

      for(let i = 0, len = str_array.length; i < len; i++) {
          str_array[i] = charMap[ str_array[i] ] || str_array[i];
      }

      let str = str_array.join('');
      let clearStr = str.replace(" ","").replace("-","").replace(/[^a-z0-9-.çöşüğı]/gi,"");

      return clearStr;
    }

    taskDetail = async () => {
      const response = await getTaskById(this.token, this.networkId, this.props.match.params.id);
      if(response.length > 0){
        this.state.countryData.forEach((c) => {
          if(c.label === response[0].data.country){
            this.setState({
              selectedCountry: c
            })
          }
        })

        this.setState({
          showTaskDetail: response[0].data,
          taskFound: true
        })
      }
    }

    async handleFileVideo(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let ext = file.name.substr(file.name.lastIndexOf('.'));
        let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + ext, file.type, file.size);
        //let changedFile = new File([blob], this.state.showTaskDetail?.uuid + ext, {type: file.type, size: file.size});
        this.setState({
          video: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFileHDVideo(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let ext = file.name.substr(file.name.lastIndexOf('.'));
        let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + "_HD" + ext, file.type, file.size);
        //let changedFile = new File([blob], this.state.showTaskDetail?.uuid + "_HD" + ext, {type: file.type, size: file.size});
        this.setState({
          hdVideo: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFileImage(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let ext = file.name.substr(file.name.lastIndexOf('.'));
        let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + ext, file.type, file.size);
        //let changedFile = new File([blob], this.state.showTaskDetail?.uuid + ext, {type: file.type, size: file.size});
        this.setState({
          image: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFileCleanVideo(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let ext = file.name.substr(file.name.lastIndexOf('.'));
        let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + "_clean" + ext, file.type, file.size);
        //let changedFile = new File([blob], this.state.showTaskDetail?.uuid + "_clean" + ext, {type: file.type, size: file.size});
        this.setState({
          cleanVideo: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFileCleanImage(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let ext = file.name.substr(file.name.lastIndexOf('.'));
        let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + "_clean" + ext, file.type, file.size);
        //let changedFile = ew File([blob], this.state.showTaskDetail?.uuid + "_clean" + ext, {type: file.type, size: file.size});
        this.setState({
          cleanImage: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFilePremierProject(event) {
      let file = event.target.files[0]
      if(file !== undefined){
        let blob = file.slice(0, file.size, file.type);
        let changedFile = this.getNewFile([blob], this.fileNameNormalizer(file.name), file.type, file.size);
        //let changedFile = new File([blob], this.fileNameNormalizer(file.name), {type: file.type, size: file.size});
        this.setState({
          premierProject: changedFile,
          leaveMessage: true
        })
      }else{
        this.setState({ leaveMessage: false })
      }
    }

    async handleFileExtraRaw(event) {
        try {
          let filesData = event.target.files;
          let files = [...this.state.files];
          Object.entries(filesData).forEach(item => {
            item.forEach(file => {
              if(file.name !== undefined){
                let blob = file.slice(0, file.size, file.type);
                let changedFile = this.getNewFile([blob], this.state.showTaskDetail?.uuid + "_extra-raw_" + this.fileNameNormalizer(file.name), file.type, file.size);
                //let changedFile = new File([blob], this.state.showTaskDetail?.uuid + "_extra-raw_" + this.fileNameNormalizer(file.name), {type: file.type, size: file.size});
                files.push(changedFile)
              }else{
                this.setState({ leaveMessage: false })
              }
            })
          })
          this.setState({ extraRawFiles: files, leaveMessage: true })
        } catch (err) {
          console.error(err, err.message)
        }
    }

    confirmRemove = (name) => {
      confirmAlert({
          title: 'Remove File',
          message: 'Are you sure you want to remove ?',
          buttons: [
          {
              label: 'Yes',
              onClick: () => this.handleRemove(name)
          },
          {
              label: 'No',
          }
          ]
      });
  };

  confirmRemoveWaiting = (name) => {
    confirmAlert({
        title: 'Remove File',
        message: 'Are you sure you want to remove ?',
        buttons: [
        {
            label: 'Yes',
            onClick: () => this.handleRemoveWaiting(name)
        },
        {
            label: 'No',
        }
        ]
    });
};

  handleRemove = (name) => {
    let filesArr = [...this.state.files];

    const index = filesArr.map(item => item.name).indexOf(name);
    filesArr.splice(index, 1);

    this.setState({
      files: filesArr
    })
  }

    selectedFilesControl() {
      return this.state.files.map((item, index) => {
        return (
          <ListGroup key={index}>
            <ListGroupItem>
              <span>{ item.name.split('_').pop() }</span>
              <Button type="button" className="float-right" color="danger" size="sm" onClick={() => this.confirmRemove(item.name)}>
                  Remove
              </Button>
            </ListGroupItem>
        </ListGroup>
        )}
      )
    }

    async handleFileVideoUpload(event) {
      try {
        let filesData = event.target.files;
        let files = [...this.state.files];
        Object.entries(filesData).forEach(item => {
          item.forEach(file => {
            if(file.name !== undefined){
              let blob = file.slice(0, file.size, file.type);
              let changedFile = this.getNewFile([blob], `${this.state.showTaskDetail?.uuid}_${this.state.showTaskDetail?.questType}_${this.state.showTaskDetail?.assignedUserId}_${this.fileNameNormalizer(file.name)}`, file.type, file.size); 
              //let changedFile = new File([blob], `${this.state.showTaskDetail?.uuid}_${this.state.showTaskDetail?.questType}_${this.state.showTaskDetail?.assignedUserId}_${this.fileNameNormalizer(file.name)}`, {type: file.type, size: file.size});
              files.push(changedFile)
            }else{
              this.setState({ leaveMessage: false })
            }
          })
        })
        this.setState({ files, leaveMessage: true })
      } catch (err) {
        console.error(err, err.message)
      }
    }

    getFileName = (file) => {      
      let endIndex= file.lastIndexOf('.');
      let _fileName = file.substr(0, endIndex).replace(/\./g,'');
      let _fileExtension = file.substr(endIndex);
      return _fileName + _fileExtension;
    }

    getNewFile = (blob, fileName, type, size) => {
      fileName = this.getFileName(fileName);
      return new File(blob, fileName, {type: type, size: size})
    }

    async startUpload(file) {
      try {
          
          const params = {
            fileName: this.getFileName(file.name),
            fileType: file.type
          };

          const headers = {
            'authorization' : 'Bearer ' + this.token,
            'networkId': this.networkId,
            'TaskId': this.props.match.params.id,
          }

          let resp = await axios.get(`${this.state.backendUrl}/start`, { params, headers: headers, cancelToken: this.signal.token })
          let { uploadId } = resp.data;

          let uploadIdArr = [...this.state.uploadId]
          uploadIdArr.push({ uploadId })

          this.setState({
            uploadId: uploadIdArr,
          })

          return new Promise(resolve => {
              this.uploadMultipartFile(file, this.state.inc++).then(() => {
                  resolve()
              })
          })
        } catch (err) {          
          RollbarErrorTracking.logErrorInRollbar(err);
          console.log(err)
        }
    }

    /* eslint-disable */
    async uploadMultipartFile(file, inc) {
      try {
          let CHUNK_SIZE;
          const fileSize = file.size
          if(fileSize < 100000000){ // < 100 MB
            CHUNK_SIZE = 20000000 // 20 MB
          }else if(fileSize < 500000000){ // < 500 MB
            CHUNK_SIZE = 50000000 // 50 MB
          }else if(fileSize > 500000000){ // >= 1 GB
            CHUNK_SIZE = 100000000 // 100 MB
          }
          const type = file.type
          const CHUNKS_COUNT = Math.floor(fileSize / CHUNK_SIZE) + 1
          let promisesArray = []
          let start, end, blob

          const headers = {
            'mimetype': type,
            'size': fileSize,
            'authorization' : 'Bearer ' + this.token,
            'networkId': this.networkId,
            'TaskId': this.props.match.params.id,
          }

          let totalUpload = {};

          for (let index = 1; index < CHUNKS_COUNT + 1; index++) {
            start = (index - 1) * CHUNK_SIZE
            end = (index) * CHUNK_SIZE
            blob = (index < CHUNKS_COUNT) ? file.slice(start, end) : file.slice(start)
            let getUploadUrlResp = await axios.get(`${this.state.backendUrl}/geturl`, {
              cancelToken: this.signal.token,
              params: {
                fileName: this.getFileName(file.name),
                partNumber: index,
                uploadId: this.state.uploadId[inc].uploadId
              },
              headers : headers
            })

            //let { presignedUrl } = getUploadUrlResp.data
            let uploadResp = await axios.put(getUploadUrlResp.data.presignedUrl, blob, {
              cancelToken: this.signal.token,
              headers: {
                'Content-Type': file.type,
                'networkId': this.networkId,
                'TaskId': this.props.match.params.id,
              },
              onUploadProgress: async (progressEvent) => {

                let keyname = getUploadUrlResp.data.presignedUrl.substr(getUploadUrlResp.data.presignedUrl.indexOf('partNumber='), 15);

                totalUpload[`${keyname}`] = progressEvent.loaded;

               this.setState({
                  uploadVideoProgress: totalUpload                  
                })

              }
            }).then(data => {
              return data.headers.etag
            });
            promisesArray.push(uploadResp)
          }

          let resolvedArray = await Promise.all(promisesArray)

          let uploadPartsArray = []
          resolvedArray.forEach((resolvedPromise, index) => {
            uploadPartsArray.push({
              ETag: resolvedPromise,
              PartNumber: index + 1
            })
          })

          let completeUploadResp = await axios.post(`${this.state.backendUrl}/complete`, {
            cancelToken: this.signal.token,
            params: {
              fileName: this.getFileName(file.name),
              parts: uploadPartsArray,
              uploadId: this.state.uploadId[inc].uploadId
            }
          },
          {
            headers : headers
          }).then(() => {
            this.i++
            this.setState({
              uploadVideoProgress: {},
              uploadedFiles: [...this.state.uploadedFiles, file.name]
            })

            if(this.state.files.length === this.i){
              this.setState({ showUploadArea: false })
            }
          })

        } catch (err) {
          console.log(err)
          RollbarErrorTracking.logErrorInRollbar(err);
        }
    }

    videoUpload = async (file) =>{
      if(this.state.files.length > 0){
        await this.startUpload(file);
      }
    }

    cancelUpload() {
      this.signal.cancel("Upload cancelled");
      this.setState({
        showUploadArea: false,
      })

      let lastFiles = [...this.state.files];
      lastFiles = lastFiles.filter(val => !this.state.uploadedFiles.includes(val.name));

      this.setState({
        files: lastFiles
      })

      this.i = 0;
    }

    progressArea(){
        let fileName = this.state.files[this.i]?.name;
        let fileSize = this.state.files[this.i]?.size;
        let pureFile = fileName?.substring(fileName?.lastIndexOf("_") + 1, fileName?.indexOf("."));
        let ext = fileName?.substring(fileName?.lastIndexOf("."));
        let waitingForUploads = [...this.state.files];
        let waitingForUploadNames = [];
        waitingForUploads = waitingForUploads.filter(val => !this.state.uploadedFiles.includes(val.name));
        waitingForUploads.forEach((item) => {
          let name = item.name;
          waitingForUploadNames.push( name?.substring(name?.lastIndexOf("_") + 1, name?.indexOf(".")) + name?.substring(name?.indexOf(".")))
        })

        let progressValue = 0;        
        for(let ind = 0; ind < Object.keys(this.state.uploadVideoProgress).length; ind++){
          progressValue = progressValue + this.state.uploadVideoProgress[Object.keys(this.state.uploadVideoProgress)[ind]]
        }
        
        if(fileSize !== undefined) {
          progressValue = ((progressValue /  this.state.files[this.i]?.size) * 100).toFixed(3);
        }
        else {
          progressValue = 0;
        }

        return(
            <div className="file-upload-progress-area">
                <img width="100" className="mb-2" src="data:image/png;base64,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" alt="zoomin"></img>
                { waitingForUploadNames.map((item, index) => <h5 key={index}>Waiting: { item } <img src="https://samherbert.net/svg-loaders/svg-loaders/three-dots.svg" className="ml-2" width="12" alt="zoomin"></img> </h5> )}
                <h4 style={{color: "#fff"}}>Uploading: { pureFile + ext } - {(this.state.files[this.i]?.size / (1024*1024)).toFixed(2) } MB | <strong>%{ progressValue }</strong></h4>
                <Progress animated color="success" value={ progressValue } />
                {this.state.uploadedFiles.map((item, i) => <h5 className="upload-area-uploaded-files" key={i}>{'Uploaded: ' + item} <i className="ni ni-check-bold"></i></h5>)}
                <div className="cancel-upload">
                  <Button size="sm" color="danger" className="mt-1" onClick={this.cancelUpload.bind(this)}>Cancel Upload</Button>
                </div>
            </div>
        )
    }

    downloadOneByOneAction = async (key) => {
      const bucketFolderId = this.state.showTaskDetail.bucketFolderId;
      const cultureId = this.state.showTaskDetail.assetFiles !== undefined ? this.state.showTaskDetail.cultureId : this.state.showTaskDetail.rawCultureId;
      const alert = this.props.alert;

      let files = [...this.state.downloadedFiles, key]
        this.setState({
            downloadedFiles: files,
            showDownloadArea: true
        })

      const response = await downloadFile(this.token, this.networkId, bucketFolderId, cultureId, key);
            fetch(response.presignedUrl, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
              saveAs(blob, key)
              let index = this.state.downloadedFiles.map((item) => item).indexOf(key);
              files.splice(index, 1);

              this.setState({
                  downloadedFiles: files
              })

              if(this.state.downloadedFiles.length <= 0){
                  this.setState({
                      showDownloadArea: false
                   })
              }
            })
            .then(alert.show('Download is started. Please Wait !'))
    }

    downloadOneByOne() {
      let rawFiles = []


      if(this.state.showTaskDetail?.assetFiles !== undefined){
        rawFiles.push(
          this.state.showTaskDetail?.assetFiles?.premierProject?.key,
          this.state.showTaskDetail?.assetFiles?.image?.key,
          this.state.showTaskDetail?.assetFiles?.video?.key,
          this.state.showTaskDetail?.assetFiles?.videoHD?.key)

          if(this.state.showTaskDetail?.questType === "editor"){
            rawFiles.push(
              this.state.showTaskDetail?.assetFiles?.cleanVideo?.key,
            this.state.showTaskDetail?.assetFiles?.cleanImage?.key
            )
          }

          if(this.state.showTaskDetail.assetFiles?.extraRawFiles?.length > 0){
            this.state.showTaskDetail.assetFiles?.extraRawFiles.forEach((e) => {
              rawFiles.push(e.key)
            })
          }
      }else {
        
        if(this.state.showTaskDetail?.rawAssetFiles?.cleanVideo !== undefined)
          rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.cleanVideo?.key)
        
        if(this.state.showTaskDetail?.rawAssetFiles?.cleanImage !== undefined)
          rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.cleanImage?.key)
        
        if(this.state.showTaskDetail?.rawAssetFiles?.premierProject !== undefined)
          rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.premierProject?.key)
                               

        if(this.state.showTaskDetail?.questType === "editor") {
          
          if(this.state.showTaskDetail?.rawAssetFiles?.image !== undefined)
            rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.image?.key)
        
          if(this.state.showTaskDetail?.rawAssetFiles?.video !== undefined)
            rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.video?.key)
        
          if(this.state.showTaskDetail?.rawAssetFiles?.videoHD !== undefined)
            rawFiles.push(this.state.showTaskDetail?.rawAssetFiles?.videoHD?.key)         

         if(rawFiles.length === 0) {
            rawFiles.push(this.state.showTaskDetail?.rawAssetFiles);
          }

          if(this.state.showTaskDetail.rawAssetFiles?.extraRawFiles?.length > 0){
            this.state.showTaskDetail.rawAssetFiles?.extraRawFiles.forEach((e) => {
              rawFiles.push(e.key)
            })
          }
        }
    }

      return(
        <>
        { rawFiles[0] !== undefined ?
        <Dropdown isOpen={this.state.btnDropright} toggle={() => { this.setState({ btnDropright: !this.state.btnDropright }); }}>
          <DropdownToggle caret>
            Download With Select &nbsp;
          </DropdownToggle>
          <DropdownMenu>
            { rawFiles.map((item, index) =>
              item !== undefined ?
              <DropdownItem  key={index} onClick={() => this.downloadOneByOneAction(item)}> { item } &nbsp; <i className="ni ni-cloud-download-95" /> </DropdownItem>
              : ""
            )}
          </DropdownMenu>
        </Dropdown> : ""}
        </>
      )
    }

    onDownloadClick = async e => {
      e && e.preventDefault();
      const alert = this.props.alert;
      const bucketFolderId = this.state.showTaskDetail.bucketFolderId;
      const rawCultureId = this.state.showTaskDetail.rawCultureId;
      const cultureId = this.state.showTaskDetail.cultureId;
      let aFiles = [];
      let rFiles = [];
      //editor asseti yuklemis
      if(this.state.showTaskDetail.assetFiles && this.state.showTaskDetail.questType !== "localizer"){
          aFiles.push(this.state.showTaskDetail.assetFiles?.videoHD.key,
                      this.state.showTaskDetail.assetFiles?.cleanVideo.key,
                      this.state.showTaskDetail.assetFiles?.cleanImage.key,
                      this.state.showTaskDetail.assetFiles?.premierProject.key,
                      this.state.showTaskDetail.assetFiles?.image.key,
                      this.state.showTaskDetail.assetFiles?.video.key)

                      if(this.state.showTaskDetail.assetFiles?.extraRawFiles?.length > 0){
                        this.state.showTaskDetail.assetFiles?.extraRawFiles.forEach((e) => {
                            aFiles.push(e.key)
                        })
                    }

      }else if(this.state.showTaskDetail.assetFiles && this.state.showTaskDetail.questType === "localizer"){
        aFiles.push(
          this.state.showTaskDetail.assetFiles?.image.key,
          this.state.showTaskDetail.assetFiles?.video.key,
          this.state.showTaskDetail.assetFiles?.videoHD.key,
          this.state.showTaskDetail.assetFiles?.premierProject.key)

          if(this.state.showTaskDetail.assetFiles?.extraRawFiles?.length > 0){
            this.state.showTaskDetail.assetFiles?.extraRawFiles.forEach((e) => {
                aFiles.push(e.key)
            })
        }
      }

//editor henuz yuklememis dosyalari ve localizer videolari yuklememis ve vj videolari yuklemis
      if(this.state.showTaskDetail.assetFiles === undefined) {
        if(this.state.showTaskDetail.questType === "localizer") {
          rFiles.push(
            this.state.showTaskDetail.rawAssetFiles?.premierProject.key,
            this.state.showTaskDetail.rawAssetFiles?.cleanVideo.key,
            this.state.showTaskDetail.rawAssetFiles?.cleanImage.key
            /*,this.state.showTaskDetail.rawAssetFiles?.image.key,
            this.state.showTaskDetail.rawAssetFiles?.video.key,
            this.state.showTaskDetail.rawAssetFiles?.videoHD.key,*/
            )
            /*
            if(this.state.showTaskDetail.rawAssetFiles?.extraRawFiles?.length > 0){
              this.state.showTaskDetail.rawAssetFiles?.extraRawFiles.forEach((e) => {
                  rFiles.push(e.key)
              })
            }
          */
        }
        else {
          rFiles = this.state.showTaskDetail.rawAssetFiles;
        }

        let files = [...this.state.downloadedFiles, ...rFiles]
        this.setState({
            downloadedFiles: files,
            showDownloadArea: true
        })
        rFiles.forEach(async (assetFile) => {
          const response = await downloadFile(this.token, this.networkId, bucketFolderId, rawCultureId, assetFile);
          fetch(response.presignedUrl, { method: 'GET' })
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, assetFile)
            let index = this.state.downloadedFiles.map((item) => item).indexOf(assetFile);
            files.splice(index, 1);

            this.setState({
                downloadedFiles: files
            })

            if(this.state.downloadedFiles.length <= 0){
                this.setState({
                    showDownloadArea: false
                 })
            }
          })
          .then(alert.show('Download is started. Please Wait !'))
        })
      }else{        
        if(this.state.showTaskDetail.assetFiles){          

          let files = [...this.state.downloadedFiles, ...aFiles]
          this.setState({
              downloadedFiles: files,
              showDownloadArea: true
          })
          aFiles.forEach(async (assetFile) => {
            const response = await downloadFile(this.token, this.networkId, bucketFolderId, cultureId, assetFile);
            fetch(response.presignedUrl, { method: 'GET' })
            .then(res => res.blob())
            .then(blob => {
              saveAs(blob, assetFile)
              let index = this.state.downloadedFiles.map((item) => item).indexOf(assetFile);
              files.splice(index, 1);

              this.setState({
                  downloadedFiles: files
              })

              if(this.state.downloadedFiles.length <= 0){
                  this.setState({
                      showDownloadArea: false
                   })
              }
            })
            .then(alert.show('Download is started. Please Wait !'))
          })
      }

      }
    }

    asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    }

    onUploadClick = async e => {
      e && e.preventDefault();
      const alert = this.props.alert;
      this.signal = axios.CancelToken.source();

      if(this.state.showTaskDetail.categories.length === 0) {
          alert.show(<div style={{ textTransform: 'initial'}}>1- Select at least a category to the task<br/>2- Update the task<br/>3- Continue to upload your files.</div> );   
                
      }
      else {

        this.setState({ showUploadArea: true })

        if(this.taskType === "vj"){
            if(this.state.files.length > 0){
              let approveArr = [];

              this.state.files.forEach((item) => {
                approveArr.push({
                  "key": item.name,
                  "contentLength": item.size,
                })
              })

              this.setState({
                assetFiles: [...this.state.assetFiles, approveArr]
              })

              return this.asyncForEach( this.state.files, async (file) => {
                await this.videoUpload(file);
              })
            }else {
              alert.show("Please select file.")
            }

          }else if(this.taskType === "editor"){

           let f = [];
           let allF = [];

          if(this.state.video !== null &&
            this.state.image !== null &&
            this.state.cleanVideo !== null &&
            this.state.cleanImage !== null &&
            this.state.premierProject !== null &&
            this.state.hdVideo !== null){
            f.push(              
              this.state.video,
              this.state.hdVideo,
              this.state.image,
              this.state.cleanVideo,
              this.state.cleanImage,
              this.state.premierProject,);

            this.setState({ files: [] }, () => {
              allF = [...this.state.files, ...f]
              this.setState({
                files: [...this.state.files, ...allF]
              }, () => {
                this.setState({
                  files: [...this.state.files, ...this.state.extraRawFiles]
                }, () => {
                  if(this.state.extraRawFiles.length > 0){
                    let editorExtraRawFiles = [];
                    this.state.extraRawFiles.forEach((item) => {
                      editorExtraRawFiles.push({
                        "key": item.name,
                        "contentLength": item.size,
                      })
                    })
                    this.setState({
                      assetFiles: {
                        videoHD: {
                          "key": this.state.hdVideo?.name,
                          "contentLength": this.state.hdVideo.size,
                        },
                        video: {
                          "key": this.state.video?.name,
                          "contentLength": this.state.video.size,
                        },
                        image: {
                          "key": this.state.image?.name,
                          "contentLength": this.state.image.size,
                        },
                        cleanVideo: {
                          "key": this.state.cleanVideo?.name,
                          "contentLength": this.state.cleanVideo.size,
                        },
                        cleanImage: {
                          "key": this.state.cleanImage?.name,
                          "contentLength": this.state.cleanImage.size,
                        },
                        premierProject: {
                          "key": this.state.premierProject?.name,
                          "contentLength": this.state.premierProject.size,
                        },
                        extraRawFiles: editorExtraRawFiles,
                      }
                  })
                  }else {
                    this.setState({
                      assetFiles: {
                        videoHD: {
                          "key": this.state.hdVideo?.name,
                          "contentLength": this.state.hdVideo.size,
                        },
                        video: {
                          "key": this.state.video?.name,
                          "contentLength": this.state.video.size,
                        },
                        image: {
                          "key": this.state.image?.name,
                          "contentLength": this.state.image.size,
                        },
                        cleanVideo: {
                          "key": this.state.cleanVideo?.name,
                          "contentLength": this.state.cleanVideo.size,
                        },
                        cleanImage: {
                          "key": this.state.cleanImage?.name,
                          "contentLength": this.state.cleanImage.size,
                        },
                        premierProject: {
                          "key": this.state.premierProject?.name,
                          "contentLength": this.state.premierProject.size,
                        }
                      }
                  })
                  }

                return this.asyncForEach( this.state.files, async (file) => {
                  await this.videoUpload(file);
                })

                })
              })
            })
          }else {
            const alert = this.props.alert;
            alert.show("Please select required files");
          }
        }else if(this.taskType === "localizer"){
          if(this.state.video !== null &&
            this.state.image !== null &&
            this.state.premierProject !== null &&
            this.state.hdVideo !== null){
              let f = [];
              let allF = [];

              f.push(
                this.state.hdVideo,
                this.state.video,
                this.state.image,
                this.state.premierProject);

                this.setState({ files: [] }, () => {
                  allF = [...this.state.files, ...f]

                  this.setState({
                    files: allF
                  }, () => {

                    this.setState({
                      assetFiles: {
                        videoHD: {
                          "key": this.state.hdVideo?.name,
                          "contentLength": this.state.hdVideo.size,
                        },
                        video: {
                          "key": this.state.video?.name,
                          "contentLength": this.state.video?.size,
                        },
                        image: {
                          "key": this.state.image?.name,
                          "contentLength": this.state.image?.size,
                        },
                        premierProject: {
                          "key": this.state.premierProject?.name,
                          "contentLength": this.state.premierProject?.size,
                        }
                      }
                  })

                  /*return this.state.files.forEach(async file => {
                    await this.videoUpload(file);
                  })*/

                  return this.asyncForEach( this.state.files, async (file) => {
                    await this.videoUpload(file);
                  })

                })
              })

        }else{
          const alert = this.props.alert;
          alert.show("Please select requireds")
        }

        return this.asyncForEach( this.state.files, async (file) => {
          await this.videoUpload(file);
        })

        }else {
          this.setState({ files: [] })
          const alert = this.props.alert;
          alert.show("Please select required files")
        }
      }
    }

    onApproveClick = async e => {
      e && e.preventDefault();

      const alert = this.props.alert;      

      if(this.state.uploadedFiles.length > 0){
        if(this.taskType === "vj"){
          const response = await readyToApproveTask(this.token, this.networkId, this.props.match.params.id, this.state.assetFiles[0]);

          if(response.status === 404){
            alert.show('Task is not suitable for approving')
          }else if(response.status === 200){
            this.setState({
              leaveMessage: false
            })
            alert.show('Waiting for approve')
            this.props.history.push('/admin/my-tasks')
          }else if(response.status === 403){
            alert.show('Insufficent Permission !')
          }
        }else if(this.taskType === "editor"){
          const response = await readyToApproveEditorTask(this.token, this.networkId, this.props.match.params.id, this.state.assetFiles);

          if(response.status === 404){
            alert.show('Task is not suitable for approving')
          }else if(response.status === 200){
            this.setState({
              leaveMessage: false
            })
            alert.show('Waiting for approve')
            this.props.history.push('/admin/my-tasks')
          }else if(response.status === 403){
            alert.show('Insufficent Permission !')
          }
        }else if(this.taskType === "localizer"){          
          const response = await localizerComplete(this.token, this.networkId, this.props.match.params.id, this.state.assetFiles);

          if(response.status === 404){
            alert.show('Task is not suitable for approving')
          }else if(response.status === 403){
            alert.show('Insufficent Permission !')
          }else{
            this.setState({
              leaveMessage: false
            })
            this.refreshPage();
          }
        }

      } else {
        const alert = this.props.alert;
        alert.show('Please upload a file.')
      }
    }

    async assignToMe(taskId){
      const response = await assignToMe(this.token, this.networkId, taskId);
      if(response.status === 200){
          this.refreshPage();
      }
      else {
        const alert = this.props.alert;
        alert.show('An error occured while assinging the task');
      }
  }

  setKeywords = () => {
    let initKeywords = [];
          this.state.showTaskDetail.keywords.map((keyword, index) => {
            initKeywords.push({
                value: index,
                label: keyword
            })
        })

    if(initKeywords.length > 0){
        this.setState({
            keywords: initKeywords
        })
      }
    }

    async componentDidMount() {
      await this.getCountry();
      await this.taskDetail();
      await this.getCategories();
      await this.getCultures();
      this.setKeywords();
      this.initKeywordsAndCategories();

      let elements = [];

      if(this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.status === 8){
        const localizerCDNPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/8/`;
        const cleanImage = this.state.showTaskDetail.rawAssetFiles.cleanImage.key;
        const cleanVideo = this.state.showTaskDetail.rawAssetFiles.cleanVideo.key;
        const imageKey = this.state.showTaskDetail.rawAssetFiles.image.key;
        const videoKey = this.state.showTaskDetail.rawAssetFiles.video.key;

        elements.push({
          href: `${localizerCDNPath}${cleanImage}`,
          type: "image",
          title: `Clean Image: ${cleanImage}`,
        })

        elements.push({
          href: `${localizerCDNPath}${cleanVideo}`,
          type: "video",
          title: `Clean Video: ${cleanVideo}`,
        })

        elements.push({
          href: `${localizerCDNPath}${imageKey}`,
          type: "image",
          title: `Image: ${imageKey}`,
        })

        elements.push({
          href: `${localizerCDNPath}${videoKey}`,
          type: "video",
          title: `Video: ${videoKey}`,
        })
      }

      if(this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.status === 9){
        const localizerCDNPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/${this.state.showTaskDetail?.cultureId}/`;
        const imageKey = this.state.showTaskDetail.assetFiles.image.key;
        const videoKey = this.state.showTaskDetail.assetFiles.video.key;

        elements.push({
          href: `${localizerCDNPath}${imageKey}`,
          type: 'image',
          title: `Image: ${imageKey}`
        })

        elements.push({
          href: `${localizerCDNPath}${videoKey}`,
          type: 'video',
          title: `Video: ${videoKey}`
        })
      }

      this.setState({ elements })

        window.zoomGallery = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: false,
            elements: this.state.elements,
        });

      this.setState({
          taskEditTitle: this.state.showTaskDetail?.title,
          taskEditCity: this.state.showTaskDetail?.city,
          taskEditCountry: this.state.showTaskDetail?.country,
          taskEditDescription: this.state.showTaskDetail?.description,
          taskEditIdea: this.state.showTaskDetail?.ideaOriginator,
          taskEditPrice: this.state.showTaskDetail?.price
      })
    }

    update = async e => {
      e && e.preventDefault();
      const response = await updateTask(this.token,
                                        this.networkId,
                                        this.props.match.params.id,
                                        this.state.taskEditTitle,
                                        this.state.taskEditDescription,
                                        this.state.keywordsLabel,
                                        this.state.categoriesValue,
                                        this.state.taskEditIdea,
                                        this.state.taskEditCity,
                                        this.state.selectedCountry !== null ? this.state.selectedCountry.label : this.state.showTaskDetail.country);

      if(response.status === 200){
          this.refreshPage();
      }else {
        const alert = this.props.alert;
        alert.show('An error occured while updating the task')
      }
  }

  addToCms = async (taskId) => {
    const alert = this.props.alert;
    this.setState({ disableAddToCmsButton: true });
    const response = await addToCms(this.token, this.networkId, taskId);
    if(response.status === 200){
        this.taskDetail();        
        alert.show("Added To CMS !");
    }
    else {
      alert.show("An error occured while adding to CMS");
    }
    this.setState({ disableAddToCmsButton: false });
}

    confirm = () => {
      confirmAlert({
          title: 'Update Task',
          message: 'Are you sure you want to update ?',
          buttons: [
          {
              label: 'Yes',
              onClick: () => this.update()
          },
          {
              label: 'No',
          }
          ]
      });
  };

  confirmCMS = (id) => {
    confirmAlert({
        title: 'Add To CMS',
        message: 'Are you sure you want to add to cms ?',
        buttons: [
        {
            label: 'Yes',
            onClick: () => this.addToCms(id)
        },
        {
            label: 'No',
        }
        ]
    });
};

  confirmApprove = () => {
    confirmAlert({
        title: 'Task Approve/Complete',
        message: 'Are you sure you want to this ?',
        buttons: [
        {
            label: 'Yes',
            onClick: () => this.onApproveClick()
        },
        {
            label: 'No',
        }
        ]
    });
};

  handleChangeKeywords = keywords => {
    let initKeywordsLabel = [];
    if(keywords?.length > 0){
      keywords.map((keyword) => {
          initKeywordsLabel.push(keyword.label)
      })
    }

    this.setState({
        keywords: keywords,
        keywordsLabel: initKeywordsLabel
    })
  }

  handleChangeCategory = currentCategories => {
      let initCategoriesValue = [];
      if(currentCategories?.length > 0){
        currentCategories.map((category) => {
            initCategoriesValue.push(category.value)
        })
      }

      this.setState({
          currentCategories: currentCategories,
          categoriesValue: initCategoriesValue
      })
  }

  initKeywordsAndCategories = () => {
      let initKeywordsLabel = [];
      let initCategoriesValue = [];
      this.state.keywords.map((keyword) => {
          initKeywordsLabel.push(keyword.label)
      })

      this.state.currentCategories.map((category) => {
          initCategoriesValue.push(category.value)
      })

      this.setState({
          categoriesValue: initCategoriesValue,
          keywordsLabel: initKeywordsLabel
      })
  }

  showAsset = (taskId) => {
    this.props.history.push(`/admin/published-edit/asset/${taskId}`)
  }

  assignConfirm = (id) => {
    confirmAlert({
        title: 'Assign Task',
        message: 'Are you sure you want to assign ?',
        buttons: [
        {
            label: 'Yes',
            onClick: () => this.assignToMe(id)
        },
        {
            label: 'No',
        }
        ]
    });
};

  handleChangeCountry = selectedCountry => {
    this.setState({ selectedCountry })
  }

  cultureNameConverter(cultureId) {
    return this.state.cultureData.map((culture) => {
        if(cultureId === culture?.Id){
            return culture.Name
        }
    })
  }

    render() {
        return (
            <div>
               {this.state.showUploadArea ? <div className="zoom-blur"></div> : "" }
               {this.state.showUploadArea ? this.progressArea() : "" }
                <Header/>
                { this.state.taskFound ? <Container className="mt-10">
                { this.state.showDownloadArea ? this.downloadMessage() : ""}
                <Prompt
                  when={this.state.leaveMessage}
                  message='You have unsaved changes, are you sure you want to leave?'
                />
                <Form>
                      { this.state.showTaskDetail?.questType === "localizer" ?
                      <FormGroup>
                        <h3 className="culture-title"><i className="ni ni-world" /> Culture: { this.cultureNameConverter(this.state.showTaskDetail?.cultureId) }</h3>
                      </FormGroup> : "" }

                      <FormGroup>
                          <Label for="task">Task Title</Label>
                          <Input type="text" name="taskEditTitle" id="task_Edit_title" value={this.state.taskEditTitle} onChange={this.handleChange}/>
                      </FormGroup>

                      <FormGroup>
                          <Label for="task">Task Description</Label>
                          <Input type="text" name="taskEditDescription" id="task_Editdesc" value={this.state.taskEditDescription} onChange={this.handleChange}/>
                      </FormGroup>

                      <FormGroup>
                          <Label for="task">Task City</Label>
                          <Input type="text" name="taskEditCity" id="task_Edit_city" value={this.state.taskEditCity} onChange={this.handleChange}/>
                      </FormGroup>

                      <FormGroup>
                          <Label for="task">Task Country</Label>
                          <Select
                              name="country"
                              placeholder="Select Country"
                              value={this.state.selectedCountry}
                              options={ this.state.countryData }
                              onChange={ this.handleChangeCountry }
                          />
                      </FormGroup>

                      <FormGroup>
                            <Label for="asset">Keywords</Label><br></br>
                            <CreatableSelect
                            value={ this.state.keywords }
                            isMulti
                            name="keywords"
                            options={ this.state.keywords }
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.handleChangeKeywords}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="asset">Category</Label><br></br>
                            <Select
                            value={ this.state.currentCategories }
                            isMulti
                            name="keywords"
                            options={ this.state.categories }
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={this.handleChangeCategory}
                            />
                        </FormGroup>

                      <FormGroup>
                          <Label for="task">Idea Originator</Label>
                          <Input type="text" name="taskEditIdea" id="task_Edit_idea" value={this.state.taskEditIdea} onChange={this.handleChange}/>
                      </FormGroup>

                      { this.state.showTaskDetail.parentTaskId !== null ? 
                            <FormGroup>
                                <Label><strong>Parent Task Id: <a href="#" onClick={(e) => { e.preventDefault(); this.props.history.push(`/admin/parent-detail/${this.state.showTaskDetail.parentTaskId}`)}}>{this.state.showTaskDetail.parentTaskId}</a></strong></Label>
                            </FormGroup> : ''
                      }

                      {this.state.showTaskDetail?.questType === "vj" ?
                      <FormGroup>
                          <Label for="task">Price</Label>
                          <Input type="text" name="taskEditPrice" id="task_Edit_idea" value={this.state.taskEditPrice} onChange={this.handleChange}/>
                      </FormGroup> : "" }
                  </Form>

                  { this.state.showTaskDetail?.status === 1 &&
                    this.state.showTaskDetail?.createdBy === this.state.showTaskDetail?.assignedUserId ?
                    <Button onClick={this.confirm}>Update Task</Button> : ""
                  }

                  { this.state.showTaskDetail?.status === 7 || this.state.showTaskDetail?.status === 9 ?
                    <Button disabled={this.state.disableAddToCmsButton} onClick={() => this.confirmCMS(this.props.match.params.id)} color="success">Add to CMS</Button> : ""
                  }

                  { this.state.showTaskDetail?.status === 11 ?
                      <Button onClick={() => this.showAsset(this.state.showTaskDetail.assetId)} color="success">Show Asset</Button> : ""
                  }

                  { this.state.showTaskDetail?.status === 8 &&
                    this.state.showTaskDetail?.questType === "localizer" ?
                    <Button onClick={this.confirm}>Update Task</Button> : ""
                  }

                { this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.assignedUserId === null
                  ? <Button color="warning" onClick={() => this.assignConfirm(this.props.match.params.id)}>Assign To Me</Button> : ""
                }

                { this.state.showTaskDetail?.questType === "localizer"
                  ? <Button color="success" onClick={() => window.zoomGallery.open()}>Show Gallery</Button> : ""
                }

                  {this.state.showTaskDetail?.questType === "editor" || this.state.showTaskDetail?.questType === "localizer" ?
                  <>
                    <Button onClick={this.onDownloadClick} color="primary" data-clipboard-text="cloud-download-95" type="button"><div className="download-button"><i className="ni ni-cloud-download-95"></i><span>Download All Files</span></div></Button>
                    { this.downloadOneByOne() }
                  </>
                   : ""}
                  <hr/>
                  {this.state.uploadedFiles.map((item, i) => <h4 key={i}>{'Uploaded: ' + item?.substring(item?.lastIndexOf("_") + 1, item?.indexOf(".")) + item?.substring(item?.indexOf(".")) + " | " + item}</h4>)}
                    <Form>
                        <FormGroup>
                            { this.taskType === "vj" && this.state.showTaskDetail?.status === 1 ?
                            <div>
                              { this.state.files.length > 0 ? <strong className="mb-2"> { this.state.files.length } Files</strong> : "" }
                              { this.selectedFilesControl() }
                              <Input className="mt-4 multiple-upload-input" type="file" name="file" onChange={this.handleFileVideoUpload.bind(this)} id="vjUpload" multiple />
                            </div>

                            : this.taskType === "editor" && this.state.showTaskDetail?.status === 1 ?
                            <div className="editorUploadArea">
                              <FormGroup>
                                <Label for="asset">Select Video MP4 <Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" accept=".mp4" name="file" onChange={this.handleFileVideo.bind(this)} id="videoUpload"/>
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select HQ MXF <Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" accept=".mxf" name="file" onChange={this.handleFileHDVideo.bind(this)} id="videoUpload"/>
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select Thumbnail JPEG<Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" accept=".jpg,.jpeg" name="file" onChange={this.handleFileImage.bind(this)} id="videoUpload" />
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select Clean Video HQ MXF <Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" accept=".mxf" name="file" onChange={this.handleFileCleanVideo.bind(this)} id="videoUpload"  />
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select Clean Thumbnail JPEG <Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" accept=".jpg,.jpeg" name="file" onChange={this.handleFileCleanImage.bind(this)} id="videoUpload"  />
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select Premier Project (.zip file) <Badge color="danger" pill>*required</Badge></Label>
                                <Input type="file" name="file" accept=".prproj,.zip,.rar"onChange={this.handleFilePremierProject.bind(this)} id="videoUpload" />
                              </FormGroup>

                              <FormGroup>
                                <Label for="asset">Select Extra Raw Files</Label>
                                <Input type="file" name="file" onChange={this.handleFileExtraRaw.bind(this)} id="videoUpload" multiple/>
                              </FormGroup>
                            </div>
                            : this.taskType === "localizer" && this.state.showTaskDetail?.assignedUserId !== null && this.state.showTaskDetail?.status < 9 ?
                              <div className="localizerUploadArea">
                                <FormGroup>
                                  <Label for="asset">Select HQ MXF <Badge color="danger" pill>*required</Badge></Label>
                                  <Input type="file" accept=".mxf" name="file" onChange={this.handleFileHDVideo.bind(this)} id="videoUpload"/>
                                </FormGroup>

                                <FormGroup>
                                  <Label for="asset">Select Video MP4 <Badge color="danger" pill>*required</Badge></Label>
                                  <Input type="file" accept=".mp4" name="file" onChange={this.handleFileVideo.bind(this)} id="videoUpload"/>
                                </FormGroup>

                                <FormGroup>
                                  <Label for="asset">Select Thumbnail JPEG<Badge color="danger" pill>*required</Badge></Label>
                                  <Input type="file" accept=".jpg,.jpeg" name="file" onChange={this.handleFileImage.bind(this)} id="videoUpload" />
                                </FormGroup>

                                <FormGroup>
                                  <Label for="asset">Select Premier Project (.zip file)<Badge color="danger" pill>*required</Badge></Label>
                                  <Input type="file" name="file" accept=".prproj,.zip,.rar" onChange={this.handleFilePremierProject.bind(this)} id="videoUpload" />
                                </FormGroup>
                              </div> : ""}
                        </FormGroup>
                    </Form>
                    { this.state.showTaskDetail?.status === 1 || (this.state.showTaskDetail?.assignedUserId !== null && this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.status < 9) ?
                    <div>
                      <Button onClick={this.onUploadClick}>Upload Files</Button>
                      <Button onClick={this.confirmApprove}>{this.state.showTaskDetail?.questType !== "localizer" ? "Send To Approve" : "Complete"}</Button>
                    </div>
                    : ""}
                </Container> : <div className="not-found-area"><img src="https://samherbert.net/svg-loaders/svg-loaders/puff.svg" alt="zoomin"></img></div> }
            </div>
        )
    }
}

export default withAlert()(ProcessTask)